'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var travelReady = {
    COVID_COMPLIANCE_OF_ENTRY: (0, _reactIntl.defineMessages)({
        ACKNOWLEDGED: {
            'id': 'formOverrides.travelReady.ACKNOWLEDGED',
            'defaultMessage': 'Acknowledged.'
        }
    }),
    COVID_SCREENING_ACKNOWLEDGEMENT: (0, _reactIntl.defineMessages)({
        ACKNOWLEDGED: {
            'id': 'formOverrides.travelReady.ACKNOWLEDGED',
            'defaultMessage': 'Acknowledged.'
        }
    }),
    MASK_WEARING_ACKNOWLEDGEMENT: (0, _reactIntl.defineMessages)({
        ACKNOWLEDGED: {
            'id': 'formOverrides.travelReady.MASK_ACKNOWLEDGED',
            'defaultMessage': 'Yes, I comply.'
        },
        MASK_REFUSAL: {
            'id': 'formOverrides.travelReady.MASK_REFUSAL',
            'defaultMessage': 'Or; No, I am not able to comply.'
        }
    }),
    COVID_VACCINATED_30_DAYS: (0, _reactIntl.defineMessages)({
        COVID_VACCINATED: {
            'id': 'formOverrides.travelReady.COVID_VACCINATED',
            'defaultMessage': 'Been fully vaccinated against COVID-19 with the final dose given at least 14 days prior to the start of the tour.'
        }
    }),
    COVID_VACCINATED_120_DAYS: (0, _reactIntl.defineMessages)({
        COVID_VACCINATED: {
            'id': 'formOverrides.travelReady.COVID_VACCINATED',
            'defaultMessage': 'Been fully vaccinated against COVID-19 with the final dose given at least 14 days prior to the start of the tour.'
        }
    }),
    COVID_VACCINATED_OR_PCR_TEST_30_DAYS: (0, _reactIntl.defineMessages)({
        COVID_VACCINATED: {
            'id': 'formOverrides.travelReady.COVID_VACCINATED',
            'defaultMessage': 'Been fully vaccinated against COVID-19 with the final dose given at least 14 days prior to the start of the tour.'
        },
        COVID_PCR_TEST: {
            'id': 'formOverrides.travelReady.COVID_PCR_TEST',
            'defaultMessage': 'Or; Received a negative PCR test within 96 hours prior to the start of your first G Adventures tour service.'
        }
    }),
    COVID_FDA_VACCINATED_120_DAYS: (0, _reactIntl.defineMessages)({
        COVID_FDA_VACCINATED: {
            'id': 'formOverrides.travelReady.COVID_FDA_VACCINATED',
            'defaultMessage': 'Been fully vaccinated against COVID-19 with the final dose given at least 14 days prior to the start of the tour with one of the following COVID-19 vaccines; Pfizer Bio-N-Tech, Moderna, Johnson and Johnson/Janssen or AstraZeneca/Covishield.'
        }
    }),
    COVID_FDA_VACCINATED_OR_PCR_TEST_120_DAYS: (0, _reactIntl.defineMessages)({
        COVID_FDA_VACCINATED: {
            'id': 'formOverrides.travelReady.COVID_FDA_VACCINATED',
            'defaultMessage': 'Been fully vaccinated against COVID-19 with the final dose given at least 14 days prior to the start of the tour with one of the following COVID-19 vaccines; Pfizer Bio-N-Tech, Moderna, Johnson and Johnson/Janssen or AstraZeneca/Covishield.'
        },
        COVID_PCR_TEST: {
            'id': 'formOverrides.travelReady.COVID_PCR_TEST',
            'defaultMessage': 'Or; Received a negative PCR test within 96 hours prior to the start of your first G Adventures tour service.'
        }
    })
};

exports.default = travelReady;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/travelReady.js
// module id = 1388
// module chunks = 0